import { app } from '../../../bootstrap/core';
import appFooterComponent from './appFooter.component';

app.component('appFooter', appFooterComponent);



// WEBPACK FOOTER //
// ./src/app/common/ui/appFooter/appFooter.js